import React, { Suspense, lazy } from 'react';
import Loading from '../LoadingComponent';

const HeatmapUploader = lazy(() =>
  import(/* webpackChunkName: "HeatmapUploader" */ '../../components/survey_editor/heatmap/HeatmapUploader')
);

const HeatmapUploaderComponent = ({...props}) => (
  <Suspense fallback={<Loading />}>
    <HeatmapUploader {...props} />
  </Suspense>
);

export default HeatmapUploaderComponent;
